let host, api_url

host = 'http://localhost:8080',
console.log(window.location, 9988, 999)
if (window.location.host != 'track.freight.link') { // develop1
  // 测试环境 https://truckapi.f.yizuo.ltd
  // 擎阳本地 http://192.168.0.8:5000
  host = 'https://tw.f.yizuo.ltd',
  api_url = 'https://truckapi.f.yizuo.ltd'

  // host = "https://track.freight.link",
  // api_url = "https://api.track.freight.link"
}

if (window.location.host == 'track.freight.link') { // 
  host = 'https://track.freight.link',
  api_url = 'https://api.track.freight.link'
}

export let HOST = host
export let API_URL = api_url



// WEBPACK FOOTER //
// ./src/baseurl.js